export const EXPIRED_TOKEN_MESSAGE = 'Expired JWT Token';
export const INVALID_TOKEN_MESSAGE = 'Invalid JWT Token';
export const BANNED_USER_MESSAGE = 'user.banned';